import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'converteBool' })
export class ConverteBool implements PipeTransform {
    transform(value: boolean): string {
        if (value)
            return "Sim";
        return "Não";
    }
}